import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {ImportUtil} from '../../utils/importUtil.js';

/* global customElements */
class GeoTunnelingTool extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
						
		var geoTunnelingTool = this;
		setTimeout(function(){
			geoTunnelingTool.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var geoTunnelingTool = this;

		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'dl-location-lookup',
					itemid: 'locationLookupStart',
					label: 'Start Location',
					style: 'margin-left: 5px;',
					textstyle: 'width: 250px',
					required: true,
					'classes': 'spacer-toolbar-item'
				},
				{
					tag: 'dl-location-lookup',
					itemid: 'locationLookupEnd',
					label: 'End Location',
					style: 'margin-left: 5px;',
					textstyle: 'width: 250px',
					required: true,
					'classes': 'spacer-toolbar-item'
				},
				{
					tag: 'vaadin-number-field',
					itemid: 'interval',
					name: 'interval',
					label: 'Interval',
					value: 3
				},
				{
					tag: 'vaadin-button',					
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:road', ' Tunnel')
					], 
					listeners: {
						click: function() {
							actionTunnel();
						}
					}
				},
				{									
					tag: 'div',
					style: 'float: right;margin-top: 37px;',
					children:[
						{
							tag: 'vaadin-button',																								
							'class': 'spacer-toolbar-item',
							style: '',
							children:[
								ElementUtil.makeIcon('vaadin:cog', ' Options')
							],
							listeners: {
								click: function() {
									actionRouteOptions();
								}
							}
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'vaadin-button',						
							theme: 'primary',												
							'class': 'spacer-toolbar-item',
							style: '',
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Bulk Upload')
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}
						}
					]
				}
			]
		});		
		
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [							
				{						
					path: 'field',
					header: 'Field',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.highlight) {
							root.style.backgroundColor = '#dbf6ff';
						} else {
							root.style.backgroundColor = '';
						}
						root.innerHTML = rowData.item.field;
					}
				},	
				{						
					path: 'value',
					header: 'Value',
					width: '7em'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				}
			}
		});	
				
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'geotunnelingTool',
			showDetail: false
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		geoTunnelingTool.append(flexLayout);	
		
		
		var actionTunnel = function() {
			var locationStartField = ElementUtil.query(toolbar, 'locationLookupStart');
			var locationStart = locationStartField.getValue();
			
			var locationEndField = ElementUtil.query(toolbar, 'locationLookupEnd');
			var locationEnd = locationEndField.getValue();
			
			var interval = ElementUtil.query(toolbar, 'interval').value;
			
			if (locationStart === '' || locationEnd === '') {							
				window.DL.MessageUtil.showOkMessage('Start and End location required');			 
			} else {
				var loadMask = grid.showLoading();
				
				RoutingService.getRoutingToolsService().geocode({
					rawLocation: locationStart
				}).then(function(startArray) {
					var start = startArray[0];
					if (!start.latitude || !start.longitude) {											
						locationStartField.markError('Invaild location');
						loadMask.remove();
					} else {										
						RoutingService.getRoutingToolsService().geocode({
							rawLocation: locationEnd
						}).then(function (endArray) {
							var end = endArray[0];							
							if (!end.latitude || !end.longitude) {											
								locationEndField.markError('Invaild location');
								loadMask.remove();
							} else {
								var request = {
									geoTunnelRequest: {
										trips: [
											{
												tripId: 'test',
												stops: [
													{
														latitude: start.latitude,
														longitude:	start.longitude	
													},
													{
														latitude: end.latitude,
														longitude:	end.longitude	
													}
												]
											}

										],
										milesInterval: interval
									}
								};
								
								if (geoTunnelingTool.routeOptions) {
									request.engineOptions = geoTunnelingTool.routeOptions;
								}
								
								RoutingService.getRoutingToolsService().geotunnel(request).then(function (results) {
									loadMask.remove();

									var keyValue = [];
									results.forEach(function(result) {
										if (result.failedReport) {
											keyValue.push({
												field: 'Failure Message',
												value: result.failureMessage
											});
										} else {		
											var stopId = 0;
											result.locations.forEach(function(location){
												stopId++;
												keyValue.push({
													field: 'Stop ' + stopId,
													value: ''
												});
												keyValue.push({
													field: 'Latitude',
													value: location.latitude
												});
												keyValue.push({
													field: 'Longitude',
													value: location.longitude
												});																								
											});										
											
										}

									});

									grid.items = keyValue;
								});
							}
						});
					}					
				});
				
			}
		};
		
		var actionUpload = function() {
			
			var uploadWin = ElementUtil.create({			
				tag: 'dl-dialog',
				title: 'Bulk Upload',
				icon: 'vaadin:upload',				
				width: .75,
				height: .75,
				listeners: {
					ready: function() {						
						uploadWin.show();
						
						var primaryToolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [
								{
									tag: 'div',
									innerHTML: 'Format: Text - route per line Route Id (this can anything) TAB Origin TAB Destination TAB interval'									
								},
								{
									tag: 'vaadin-button',			
									theme: 'primary',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:upload', ' Upload')
									], 
									listeners: {
										click: function() {
											actionShowUploadForm();
										}
									}
								},	
								{
									tag: 'hr'
								}
							]

						});
						
						var outputGrid = ElementUtil.create({
							tag: 'dl-backgroundoutput-grid',
							category: 'TUNNELING',
							slot: 'primary'							
						});
						
						
						var flexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								outputGrid,
								primaryToolbar
							]
						});
						uploadWin.addToContentElement(flexLayout);
						
						var actionShowUploadForm = function() {
							
							var uploadWin = ElementUtil.create({
								tag: 'dl-dialog',
								title: 'Import Routing File',
								icon: 'vaadin:upload',
								width: 450,
								height: 315,
								listeners: {
									ready: function () {
										uploadWin.show();

										var uploadHandler = function () {

											var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

											if (!uploadField.files || uploadField.files.length < 1) {
												window.DL.MessageUtil.showOkMessage('A geotunneling import file is required.');
											} else {
												uploadField.uploadFiles();
											}

										};

										var uploadFormPanel = ElementUtil.create({
											tag: 'dl-form-panel',
											itemid: 'form',
											children: [
												{
													tag: 'vaadin-text-field',
													label: 'Note',
													name: 'note',
													maxLength: 255
												},
												{
													tag: 'vaadin-upload',
													itemid: 'uploadField',
													'no-auto': true,
													'max-files': 1,
													required: true,
													target: '/api/service/routing-tools/geotunnel/upload',
													headers: ImportUtil.getUploadHeader(),
													listeners: {
														'upload-request': function (event) {
															var data = uploadFormPanel.getData();
															event.detail.formData.append('note', data.note);															
														},
														'upload-success': function (event) {
															var responseData = JSON.parse(event.detail.xhr.responseText);
															if (responseData.uploadFile) {
																//error 
																window.DL.MessageUtil.showOkMessage(
																		responseData.uploadFile + '<br>' +
																		responseData.uploadFileType ? responseData.uploadFileType : ''
																		);
															} else {
																window.DL.MessageUtil.showToast('Success', 'File will be processed in the background.', {									
																	theme: 'success'
																});															
																outputGrid.refresh();
																uploadWin.close();
															}
														}
													}
												},
												{
													tag: 'vaadin-form-layout',
													children: [
														{
															tag: 'hr',
															colspan: 2
														},
														{
															tag: 'div',
															style: 'text-align: center;',
															colspan: 2,
															defaults: {
																tag: 'vaadin-button'
															},
															children: [
																{
																	theme: 'primary',
																	children: [
																		ElementUtil.makeIcon('vaadin:upload', ' Upload')
																	],
																	listeners: {
																		click: function () {
																			if (uploadFormPanel.isValid()) {
																				uploadHandler();
																			}
																		}
																	}
																},
																{
																	theme: 'tertiary',
																	innerHTML: 'Cancel',
																	style: 'margin-left: 10px;',
																	listeners: {
																		click: function () {
																			uploadWin.close();
																		}
																	}
																}
															]
														}
													]
												}
											]
										});
										uploadWin.addToContentElement(uploadFormPanel);

									}
								}


							});		
							
						};
						
					}
				}
			});
			
			
		};
	
		
		var actionRouteOptions = function() {
			var optionWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Options',
				icon: 'vaadin:cog',
				width: .75,
				height: .75,
				listeners: {
					ready: function () {
						optionWin.show();
						
						var optionPanel = ElementUtil.create({
							tag: 'dl-routing-options-form',
							slot: 'primary',
							listeners: {
								ready: function() {
									Service.getCompanyService().getCurrentCompany().then(function(companyFull){
										RoutingService.getGeospatialOptionsService().getOptions(companyFull.company.companyId).then(function(options){
											optionPanel.loadOptions(options);				
										});
									});
								}
							}
						});
						
						var buttonBar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'footer',
							theme: 'spacing',
							style: 'text-align: center; ',
							children: [								
								{
									tag: 'vaadin-button',
									itemid: 'refresh',
									'class': 'spacer-toolbar-item',
									children:[
										ElementUtil.makeIcon('vaadin:check', ' Apply')
									], 
									listeners: {
										click: function() {											
											geoTunnelingTool.routeOptions = optionPanel.getOptions();											
											optionWin.close();
										}
									}									
								}
							]
						});
						
						var layout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								optionPanel,
								buttonBar
							]
						});	
						
						optionWin.addToContentElement(layout);
						
					}
				}
			});
			
		};		
		
	}
	
}
customElements.define('dl-geotunnel-tool', GeoTunnelingTool);

